/** The brand mark on the landing: the "candle P" sign on its midnight tile (ui/Logo). */
import { LogoMark } from "../../ui/Logo";

export function Mark({ size = 26 }: { size?: number }) {
  return <LogoMark size={size} className="mark" />;
}
